<template>
    <div :style="[{'font-family': 'sans-serif'}, {'margin': '10px'}, !isLastPage ? {'break-after': 'page'} : {}]">
        <!-- <div style="font-family: sans-serif"> -->

        <v-card>
            <v-container fluid grid-list-xl :style="[isInvoiceA5Format ? {'height': '203mm'} : {'height':'287mm'}] ">
                <v-layout row wrap>

                    <!-- Show the canceled label if the invoice is canceled -->
                    <v-flex v-if="isInvoiceCanceled" style="position: absolute; left: 20%; bottom: 66%; z-index: 10;">
                        <div style="border:1px solid red; width: fit-content; border-radius: 5px; padding: 5px;transform: rotate(-45deg); opacity: 0.4">
                            <span style="font-size: 42px; color: red">Documento Anulado</span>
                        </div>
                    </v-flex>
                    
                    <!-- Invoice Header -->
                    <v-flex xs12 pa-0 ma-0 style="position: relative; top: 0%; right: 0%; left:0%;">
                        <invoice-header
                            :fetchedInvoice="fetchedInvoice"
                            :invoicePrintLabel="invoicePrintLabel"
                            :isInvoiceA5Format="isInvoiceA5Format"
                        ></invoice-header>
                    </v-flex>

                    <!-- Invoice Body -->
                    <v-flex xs12 pa-0 ma-0>
                        <invoice-body
                            :fetchedInvoice="fetchedInvoice"
                            :sellLines="sellLines"
                            :currentPage="currentPage"
                            :totalPage="totalPage"
                            :isInvoiceCanceled="isInvoiceCanceled"
                            :isInvoiceA5Format="isInvoiceA5Format"
                        ></invoice-body>
                    </v-flex>

                    <!-- Invoice Total Value -->
                    <v-flex xs12 pa-0 ma-0 v-if="currentPage === totalPage">
                        <invoice-total-value
                            :fetchedInvoice="fetchedInvoice"
                            :sellLines="sellLines"
                            :total="total"
                            :isInvoiceA5Format="isInvoiceA5Format"
                        ></invoice-total-value>
                    </v-flex>

                    <!-- Invoice Footer -->
                    <v-flex xs12 pa-0 ma-0 style="position: absolute; bottom: 0%;">
                        <invoice-footer
                            :isInvoiceA5Format="isInvoiceA5Format"
                        ></invoice-footer>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
                                        
    </div>
        
</template>

<script>
    import InvoiceFooter from './InvoiceFooter.vue';
    import InvoiceHeader from './InvoiceHeader.vue';
    import InvoiceBody from './InvoiceBody.vue';
    import InvoiceTotalValue from './InvoiceTotalValue.vue';
    import {mapGetters} from "vuex";
    export default {
        created () {
            
        },

        data(){
            return {

            }
        },

        props: {
            total: {
                type: Number,
                default: 0,
            },
            currentPage: {
                type: Number,
                default: 0,
            },
            totalPage: {
                type: Number,
                default: 0,
            },
            invoicePrintLabel: {
                type: String,
                default: ""
            },
            fetchedInvoice: {
               type: Object,
               default: () => ({}),
            },
            sellLines: {
                type: Array,
                default: () => [],
            },
            isInvoiceA5Format: {
                type: Boolean,
                default: false,
            },
            isInvoiceCanceled: {
                type: Boolean,
                default: false,
            }
        },

        watch: {
            
        },

        components: {
            InvoiceFooter,
            InvoiceHeader,
            InvoiceBody,
            InvoiceTotalValue,            
        },

        computed: {
            ...mapGetters([
                'loggedUser',
                'getToken',
            ]),

            isLastPage(){
                return this.currentPage === this.totalPage;
            },

            selectedInvoice: {
                get(){ return this.$store.getters.getSelectedInvoice; },
                set(value){ this.$store.dispatch('setSelectedInvoice', value); }
            },

        },

        methods: {
            
        }
    }
</script>